// extracted by mini-css-extract-plugin
export default {"modal":"quoteModal_modal__e6Gs-"};